import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropDownOption } from '../drop-down.component';

@Component({
  selector: 'kion-drop-down-list-item',
  templateUrl: './drop-down-list-item.component.html',
  styleUrls: ['./drop-down-list-item.component.scss']
})
export class DropDownListItemComponent {

  @Input() option: DropDownOption;
  // tslint:disable-next-line:no-output-rename
  @Output('selected') optionSelectedEmitter: EventEmitter<DropDownOption> = new EventEmitter<DropDownOption>();

  optionSelected(): void {
    this.optionSelectedEmitter.emit(this.option);
  }
}
